import { makeStyles } from '@rbx/ui';

const useHomePageNewsCardStyles = makeStyles()((theme) => ({
  container: {
    maxHeight: 318,
    cursor: 'pointer',
    marginBottom: 16,
  },

  head: {
    marginBottom: 12,
  },

  imageLabel: {
    marginLeft: -12,
  },

  title: {
    fontWeight: 800,
    marginBottom: 12,
  },

  image: {
    height: 64,
    width: 120,
    objectFit: 'cover',
  },

  description: {
    flex: 1,
    overflow: 'hidden',
  },

  link: {
    margin: '12px 0',
    color: theme.palette.content.standard,
    textTransform: 'uppercase',
  },
}));

export default useHomePageNewsCardStyles;
